/**
 * Cliente HTTP de la pestaña Fichadas → Quilmes. Vive al lado de la vista que
 * lo usa y solo llama a rutas que `back/src/quilmes/rutas.ts` expone.
 */

import { pedir } from '../../api';

/** Una marca que el destino rechazó y todavía se puede salvar. */
export interface MarcaRechazada {
  readonly clave: string;
  readonly dni: string;
  /** Hora local "AAAA-MM-DDTHH:mm:ss". */
  readonly fechaMarca: string | null;
  readonly tipo: string;
  readonly grupo: string;
  readonly codigoError: string;
  readonly mensajeError: string;
  readonly intentos: number;
  readonly primerIntento: string | null;
  readonly ultimoIntento: string | null;
  readonly notificada: string | null;
  /** Qué hay que hacer, en lenguaje de negocio. Lo arma el servidor. */
  readonly motivo: string;
  /** Hace cuánto viene fallando. Es lo que marca la urgencia. */
  readonly horasFallando: number | null;
  /** Cuánto le queda dentro de la ventana. Negativo = ya se perdió. */
  readonly horasQueLeQuedan: number | null;
}

export interface RespuestaRechazos {
  /** Días que la integración sigue reintentando una marca. */
  readonly ventanaDias: number;
  readonly desde: string;
  /** Cuántas quedaron afuera de la ventana: ya no se reintentan solas. */
  readonly perdidas: number;
  readonly rechazos: readonly MarcaRechazada[];
}

export function listarRechazos(): Promise<RespuestaRechazos> {
  return pedir<RespuestaRechazos>('/api/quilmes/rechazos');
}

export interface ProgramacionQuilmes {
  readonly activa: boolean;
  readonly horarios: readonly string[];
  readonly ultimoEnvioEn: string | null;
  readonly ultimoResultado: string | null;
  readonly actualizadoPor: string;
  /** Hay relay y destinatarios: sin esto el aviso no sale aunque esté activo. */
  readonly correoConfigurado: boolean;
  readonly destinatarios: readonly string[];
  /** Si esta instancia del portal es la que manda el aviso. */
  readonly programadorActivo: boolean;
}

export function leerProgramacion(): Promise<ProgramacionQuilmes> {
  return pedir<ProgramacionQuilmes>('/api/quilmes/programacion');
}

export function guardarProgramacion(
  activa: boolean,
  horarios: string,
): Promise<{ activa: boolean; horarios: readonly string[] }> {
  return pedir('/api/quilmes/programacion', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ activa, horarios }),
  });
}
